import { isoWeekRange } from '../../lib/periodFormat';
import SuggestMitButton from '../nav/SuggestMitButton';
import SendDigestButton from '../nav/SendDigestButton';

/**
 * PeriodoHeader — intestazione della pagina periodo: titolo, filtro KR attivo,
 * pulsante "Suggerisci MIT" (solo per giorno/settimana), pulsante "Invia digest
 * email" (solo per settimana/mese), counter esecuzione.
 *
 * Props:
 *   - gran, label, titolo : info periodo
 *   - filtroKr            : KR oggetto se siamo in vista filtrata da un KR
 *   - exec                : { fatti, totale, percentuale }
 *   - krs                 : key_results del periodo (length per badge)
 *   - azioni, setAzioni, setMit : per il callback onPromoted di Suggest MIT
 */
export default function PeriodoHeader({
  gran, label, titolo, filtroKr, exec, krs,
  azioni, setAzioni, setMit,
}) {
  return (
    <header className="border-b border-line pb-8 mb-10" data-testid="periodo-header">
      <div className="flex items-baseline gap-3 mb-2">
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-soft">{gran}</span>
        {filtroKr && (
          <span className="font-mono text-xs uppercase tracking-[0.18em] text-mute">
            · filtro KR: {filtroKr.titolo}
          </span>
        )}
      </div>
      <h1 className="font-display tracking-tight text-3xl md:text-4xl lg:text-5xl mb-4">{titolo}</h1>

      {(gran === 'settimana' || gran === 'giorno') && (
        <div className="mb-4 flex items-center gap-3 flex-wrap">
          <SuggestMitButton
            mode={gran === 'settimana' ? 'settimana' : 'giorno'}
            value={label}
            azioni={azioni}
            kr={krs}
            onPromoted={(deletedId, mitCreato, dayPromoted) => {
              // Rimuovi azione promossa (è stata trasferita a MIT)
              setAzioni((arr) => arr.filter((x) => x.id !== deletedId));
              // Aggiungi la MIT alla vista solo se cade nel periodo corrente.
              if (mitCreato) {
                const targetDate = dayPromoted || mitCreato.data;
                let inRange = false;
                if (gran === 'giorno') {
                  inRange = targetDate === label;
                } else if (gran === 'settimana') {
                  const r = isoWeekRange(label);
                  if (r) {
                    const monIso = r[0].toISOString().slice(0, 10);
                    const sunIso = r[1].toISOString().slice(0, 10);
                    inRange = targetDate >= monIso && targetDate <= sunIso;
                  }
                }
                if (inRange) setMit((arr) => [...arr, mitCreato]);
              }
            }}
            testid={`periodo-suggerisci-mit-${gran}-btn`}
          />
          {gran === 'settimana' && (
            <SendDigestButton kind="weekly" testid="periodo-send-weekly-digest-btn" />
          )}
        </div>
      )}

      {gran === 'mese' && (
        <div className="mb-4">
          <SendDigestButton kind="monthly" testid="periodo-send-monthly-digest-btn" />
        </div>
      )}

      <div className="flex flex-wrap items-baseline gap-8 mt-4 font-mono text-xs uppercase tracking-[0.15em] text-soft">
        <div>
          <span className="text-mute mr-2">Esecuzione</span>
          <span className="text-ink text-base normal-case font-mono tabular-nums">
            {exec.fatti || 0}/{exec.totale || 0}
            {exec.percentuale != null && <span className="text-soft ml-2">· {exec.percentuale}%</span>}
          </span>
        </div>
        {krs.length > 0 && (
          <div>
            <span className="text-mute mr-2">KR coinvolti</span>
            <span className="text-ink text-base normal-case font-mono tabular-nums">{krs.length}</span>
          </div>
        )}
      </div>
    </header>
  );
}
